import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { finalize } from 'rxjs/operators';

import { LegalService } from '../../../core/api/legal-page.service';
import { LegalPage } from '../../../shared/models';
import { ToastLevel } from '../../../shared/models/toast-message.module';
import { ToastService } from '../../../shared/services/toast.service';
import { SpinnerService } from '../../../shared/spinner/spinner.service';

@Component({
  selector: 'fc-edit-legal-page',
  templateUrl: './edit-legal-page.component.html',
  styleUrls: ['./edit-legal-page.component.scss'],
})
export class EditLegalPageComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  legalForm: FormGroup = this.formBuilder.group({
    pageHtml: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
  });
  LegalPage: LegalPage;
  pageId?: number;
  editor = Editor;
  pageName: string;

  constructor(
    readonly formBuilder: FormBuilder,
    readonly route: ActivatedRoute,
    readonly legalService: LegalService,
    readonly toastService: ToastService,
    readonly router: Router,
    readonly spinnerService: SpinnerService
  ) {
    this.pageId = this.route.snapshot.params.id;
  }

  ngOnInit() {
    // Plugins to include in the build.
    if (this.pageId) {
      this.legalService.getLegalPageById(this.pageId).subscribe({
        next: (page: LegalPage) => {
          this.pageName = page.name;
          this.legalForm.controls.name.setValue(page.name, {
            emitEvent: false,
          });
          this.legalForm.controls.pageHtml.setValue(page.pageHtml, {
            emitEvent: false,
          });
        },
      });
    }
  }

  savePage(): void {
    let updatePage = new LegalPage({
      pageHtml: this.legalForm.value.pageHtml,
      name: this.legalForm.value.name,
    });
    this.legalService
      .saveLegalPage(updatePage)
      .pipe(finalize(() => this.spinnerService.hide()))
      .subscribe({
        next: () => {
          this.toastService.sendMessage('Page Updated', ToastLevel.SUCCESS);
          this.router.navigate(['admin', 'manage-legal']);
        },
        error: err => {
          this.toastService.sendMessage(`Error updating legal page: ${err}`, ToastLevel.WARN);
        },
        complete: () => {},
      });
  }
}
